import { Slide } from "./sliderComponent";
import styles from "./styles.module.scss";
import { slideChange } from "./script";
import { useRef, useState } from "react";
import CarrosselDestaquesTypes from "../../../types/CarrosselDestaques";
import { getMediaImage } from "../../../utils/images";
import { MediaSize } from "../../../types/MediaImage";
import ArrowIcon from "../../../public/static-next/arrow-left.svg";
import { gaEvents } from "../../../utils/ga_events";

interface Caroussel {
  itens: Array<CarrosselDestaquesTypes>;
}

export const CarrosselDestaques = ({ itens }: Caroussel) => {
  const sliderEl = useRef<HTMLDivElement>();
  const [activeSlide, setActiveSlide] = useState<number>(0);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <span
          id={styles.previous}
          onClick={() => {
            slideChange(sliderEl.current, "previous");
            setActiveSlide(activeSlide > 0 ? activeSlide - 1 : 0);
          }}
        >
          <ArrowIcon className={styles.arrowLeft} />
        </span>

        <span
          id={styles.next}
          onClick={() => {
            slideChange(sliderEl.current, "next");
            setActiveSlide(
              activeSlide < itens.length - 1 ? activeSlide + 1 : 0
            );
          }}
        >
          <ArrowIcon className={styles.arrowRight} />
        </span>

        <div id="slider" className={styles.slider} ref={sliderEl}>
          {itens.length > 0 &&
            itens.map((slide) => {
              return (
                <Slide
                  id={slide.databaseId}
                  key={slide.databaseId}
                  title={slide.title}
                  excerpt={slide.excerpt}
                  image={getMediaImage(slide.featuredImage, MediaSize.LARGE)}
                  link={slide.uri}
                  onClick={() => gaEvents.news.selectArticle(slide)}
                />
              );
            })}
        </div>
        <div className={styles.dots}>
          {itens.length > 0 &&
            itens.map((slide, index) => {
              return (
                <button
                  className={styles.dot}
                  role="button"
                  tabIndex={0}
                  aria-label={`Ir para o slide ${index + 1}`}
                  data-active={activeSlide === index}
                  key={slide.databaseId}
                  onClick={() => {
                    slideChange(sliderEl.current, "slideTo", slide.databaseId);
                    setActiveSlide(index);
                  }}
                ></button>
              );
            })}
        </div>
      </div>
    </section>
  );
};
